var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background-image-wrap"},[_c('img',{staticClass:"home-bgi",attrs:{"src":require("../assets/pc/background.png"),"alt":"uyu"}})])}]

export { render, staticRenderFns }